export default {
  hsk_left_time: 'Оставащо време за изпита',
  hsk_submit_paper: 'Предай изпита',
  hsk_rotate_device_title: 'Моля, завъртете устройството в хоризонтален режим',
  hsk_rotate_device_desc: 'За най-добро изпитно изживяване',
  hsk_not_finished: 'Незавършено',
  hsk_not_start: 'Не започва',
  hsk_finished: 'Завършен',
  hsk_if_test: 'Вашият предишен тест не е завършен. Искате ли да продължите изпита?',
  hsk_start_again: 'Повторен изпит',
  hsk_go_on: 'Продължи изпита',
  hsk_if_save: 'Сигурни ли сте, че искате да излезете от пробния изпит? След излизане отговорите ви ще бъдат запазени и при следващо влизане ще можете да продължите от същия модул.',
  hsk_login_filed: 'Вашите данни за влизане са изтекли и няма да запазим вашите отговори.',
  hsk_report: 'Отговор за въпросите',
  hsk_point: 'точки',
  hsk_qualified_point: '{points} точки — успешно положен',
  hsk_part1: 'Част {part}',
  hsk_accuracy1: 'Точност',
  hsk_test_again: 'Провери отново',
  hsk_example: 'Пример',
  hsk_example_eg: 'Пример',
  hsk_answer_analysis: 'Отговор на анализ:',
  hsk_your_answer: 'Вашият отговор:',
  hsk_audio_text: 'Слушане на оригинала:',
  hsk_correct_answer: 'правилния отговор：',
  hsk_listen_name: 'Слушане',
  hskk_listen_name: 'Дебагиране на устройството',
  hsk_read_name: 'Четене',
  hsk_write_name: 'Писане',
  hsk_reference_answer: 'Референтен отговор:',
  hsk_reference_answer_hskk: 'Тестово аудио съдържание:',
  hsk_submit_msg: 'Сигурни ли сте, че искате да предадете изпита?',
  hsk_homework_no_answer: 'Без отговор',
  hsk_practice_sava: 'Сигурни ли сте, че искате да излезете от упражнението? След излизане текущите отговори няма да се запазят',
  hsk_practice_go: 'Върви да тренираш.',
  hsk_practice_part: 'Модули за упражнения',
  hsk_practice_operate: 'Действие',
  hsk_practice_check: 'Преглед',
  hsk_practice_num1: 'Вярно',
  hsk_practice_num2: 'Общо {totalNum} въпроса',
  hsk_preview_listen_msg: 'Сега се възпроизвеждат инструкциите за изпита. През това време можете да щракнете върху номерата на задачите в частта по слушане, за да ги прегледате.',
  hsk_preview_listen_prompt:
    'Сега се възпроизвеждат инструкциите за изпита. През това време можете да щракнете върху номерата на задачите в частта по слушане, за да ги прегледате. Моля, не опреснявайте и не затваряйте страницата по време на изпита, в противен случай данните ще бъдат загубени.',
  hsk_enter_next_segment_msg: 'Сигурни ли сте, че искате да преминете към следващата част?',
  hsk_enter_next_segment_preview: 'Да приключи ли прегледът? След края на прегледа ще започне частта по слушане.',
  hsk_enter_next_segment_listen_tip: 'Имате {count} въпроса в частта по слушане, на които не сте отговорили,',
  hsk_enter_next_segment_listen: 'Желаете ли да предадете частта по слушане? След подаване частта приключва.',
  hsk_enter_next_segment_listen_review_start:
    'Сега е време за преглед на слушането. Разполагате с {count} минути, за да проверите своите отговори.',
  hsk_enter_next_segment_listen_review: 'Да приключи ли прегледът на слушането? След това ще започне частта по четене.',
  hsk_enter_next_segment_read_tip: 'Имате {count} въпроса в частта по четене, на които не сте отговорили,',
  hsk_enter_next_segment_read: 'Желаете ли да предадете частта по четене? След подаване не може да се връщате назад за промени.',
  hsk_enter_next_segment_write_tip: 'Имате {count} въпроса в частта по писане, на които не сте отговорили,',
  hsk_enter_next_segment_write: 'Сигурни ли сте, че искате да предадете теста?',
  hsk_end_preview: 'Край на прегледа',
  hsk_submit_listen: 'Предай частта по слушане',
  hsk_end_review: 'Край на прегледа на резултатите',
  hsk_start_exam: 'Започни изпита',
  hsk_start_exam_new: 'Старт',
  hsk_link_test: 'Щракнете, за да започнете реален пробен изпит',
  hsk_link_tips: 'Направете пробен изпит и получете официален сертификат',
  hsk_buy: 'Купи',
  hsk_test_ready: 'Подготовка преди изпит',
  hsk_test_ready_tips: 'Този изпит включва част по слушане. Моля, настройте устройството за възпроизвеждане предварително. Изпитът по слушане ще започне скоро.',
  hsk_test_content: 'Съдържание на изпита',
  hsk_test_num: 'Брой въпроси',
  hsk_total_num: 'Общо въпроси',
  hsk_test_time: 'Време за изпит',
  hsk_time_total: 'Общо време',
  hsk_test_minute: 'минути',
  hsk_about: 'около',
  hsk_abbreviation: 'Съкрати',
  hsk_determine_ans: 'Сигурни ли сте, че искате да започнете теста?',
  hsk_determine_ans_tips: 'След като започнете, няма да можете да преглеждате оригиналния текст отново.',
  no_data: 'Няма налични данни',
  hsk_question_number: 'Брой въпроси',
  hsk_test_rate: 'Дял в изпита',
  hsk_right_rate: 'Процент на правилни отговори',
  hsk_operation: 'Действие',
  hsk_skip: 'Пропусни',
  hsk_spend: 'Разход',
  hsk_cost: 'Разход',
  hsk_credit: 'Баланс',
  hsk_pay_successfully: 'Плащането е успешно',
  hsk_select_amount: 'Изберете сума за зареждане',
  button_common_ok: 'Потвърди',
  button_common_cancel: 'Отказ',
  change_lang_ok: 'Потвърди',
  change_lang_cancel: 'Отказ',
  hint_player_loader_error: 'Възпроизвеждането на аудио не бе успешно',
  hint_common_wait_loading: 'Изтегляне на ресурси…',
  button_common_hand_in: 'Предай',
  test_total_question: 'Общо {count} въпроса',
  test_release: 'Публикувай',
  test_off_shelf: 'Премахни',
  test_enable: 'Активирай',
  test_record: 'Записи от пробни изпити',
  test_finish_time: 'Време на завършване',
  test_paper: 'Изпитен лист',
  test_confirm_use: 'Потвърди активиране',
  test_confirm_off_shelf: 'Потвърди премахване',
  test_has_on_shelf: 'Публикуван',
  test_un_release: 'Непубликуван',
  test_un_enable: 'Неактивен',
  test_max_score: 'Най-висок резултат',
  test_average_score: 'Среден резултат',
  test_min_score: 'Най-нисък резултат',
  test_all: 'Всички',
  test_has_practiced: 'Завършено упражнение – виж резултата',
  test_paper_office: 'Изпитният лист е премахнат!',
  test_complete_introduce: 'Пълно описание',
  test_course_link: 'Официални курсове',
  test_about_down_load: 'Свързани изтегляния',
  test_pay: 'Плащане',
  mark_answer_user: 'Изпитван',
  mark_answer_time: 'Време на отговор',
  mark_correct_time: 'Време на проверка',
  mark_correct_status: 'Статус на проверка',
  mark_correct_user: 'Проверил',
  mark_correct_option: 'Действие',
  mark_correct_ing: 'Проверка в процес',
  mark_un_correct: 'Непроверено',
  mark_has_correct: 'Проверено',
  mark_report_tips:
    'Забележка: Частта с писане все още не се включва в общия резултат. {markNumberDesc} въпроса ще бъдат оценени от професионален оценител в рамките на 48 часа. След завършване на проверката, общият резултат ще се актуализира и ще получите известие по имейл.',
  mark_report_tips_hskk:
    'Забележка: въпроса ще бъдат оценени от професионален оценител в рамките на 48 часа. След завършване на проверката, общият резултат ще се актуализира и ще получите известие по имейл.',
  mark_submit_btn: 'Подай за проверка',
  mark_submit_tips: 'Потвърждавате ли подаването за проверка?',
  mark_back: 'Назад',
    hsk_answer_sheet: 'Лист с отговори',
  mark_correct_tips: 'Този изпитен лист вече се проверява и не може да бъде проверяван повторно!',
  mark_correct_person: 'Ръчна проверка',
  search_user_message: 'Търсене на потребителско име',
  mark_current_user: 'Текущ потребител',
  mark_correct_paper: 'Проверка',
  mark_all_status: 'Всички статуси',
  mark_all_level: 'Всички нива',
  mark_overtime: 'Просрочено',
  mark_answer: 'Отговор',
  mark_ai_suggest_score: 'AI suggested score',
  home_test_registration: 'Регистрация за изпит',
  home_word_outline: 'Проверка на речников запас',
  home_online_practice: 'Безплатен примерен тест',
  home_test: 'Пълен пробен изпит',
  home_page: 'Начална страница',
  common_text_control_speed: 'Скорост на възпроизвеждане',
  button_common_playback: 'Възпроизвеждане на запис',
  common_text_file_error: 'Неуспешно изтегляне на пакет с ресурси, опитайте отново',
  common_text_server_error: 'Опитай отново',
  common_text_none_network: 'Нестабилна мрежа',
  button_common_start_over: 'Опитайте отново',
  evaluating_tips_common: 'Разликата между прочетения запис и текста е твърде голяма, моля запишете отново',
  evaluate_common_total_score: 'Резултат',
  evaluate_common_training_remain: 'Остава:',
  evaluate_common_training_readyRcord: 'Подгответе запис',
  evaluate_common_training_atleast: 'Продължителността на записа трябва да е повече от 1 секунда',
  evaluate_common_training_atleast2: 'Продължителността на записа трябва да е повече от 2 секунди',
  evaluate_common_training_evaluting: 'Оценяване',
  evaluating_tips_additionalAndBack: 'В процеса на четене има повторно/допълнително четене, което влияе на общия резултат',
  textbook_chioce_word_text_correct_tip: 'Отговорът е верен, страхотно!',
  textbook_chioce_word_text_error_tip: 'Отговорът е грешен, опитайте отново!',
  textbook_reading_comprehension_stem: 'Разбиране на текст',
  spc_back_tips: 'Сигурни ли сте, че искате да излезете от упражнението? След излизане текущите отговори няма да се запазят',
  spc_level_text: 'Ниво тест',
  spc_capability_assessment: 'Оценка на уменията',
  spc_pick_level: 'Изберете ниво',
  spc_listen: 'Слушане',
  spc_speak: 'Говорене',
  spc_read: 'Четене',
  spc_write: 'Писане',
  spc_translation: 'Превод',
  spc_result_tips: 'След теста Вашето ниво по китайски съответства на HSK ниво {level}',
  spc_recommend_test: 'Препоръчително ниво за подготовка HSK {level}',
  spc_recommend_test1: 'Препоръчително ниво за подготовка <strong>HSK {level}</strong>',
  spc_again_test: 'Тествайте отново',
  spc_where_tips: 'Не сте сигурни за Вашето ниво по китайски?',
  spc_immediate_test: 'Тествайте сега',
  spc_test_content: 'Съдържание на теста',
  spc_test_content_desc:
    'Тестът ще оценява уменията на учащия по пет измерения: слушане, говорене, четене (гласно), писане (ръчно въвеждане или избор), превод. Въпросите се различават според нивото.',
  spc_test_timer: 'Време за тест',
  spc_test_timer_desc: 'Очаквано около 15 минути, времето се увеличава с по-високите нива.',
  spc_test_result: 'Резултати от теста',
  spc_test_result_desc: 'Помага за бързо определяне на ниво и подобряване на специфични умения',
  vocab_level_word: 'Речник за ниво {level}',
  vocab_total_item: 'Общо {total}',
  vocab_search: 'Търси по китайски знак / пинин / превод',
  vocab_all_marked: 'Всички',
  vocab_already_marked: 'Отбелязани',
  vocab_unmarked: 'Неотбелязани',
  vocabulary: 'Думи',
  vocab_pinyin: 'Пинин',
  vocab_translate: 'Превод',
  vocab_mark: 'Маркирай',
  delete_confirmation: 'Потвърждавате ли изтриването на думата?',
  cancel: 'Отказ',
  del: 'Изтриване',
  edit_vocab: 'Редактиране на дума',
  save: 'Запази',
  add_vocab: 'Добавяне на дума',
  hanzi: 'Китайски йероглиф',
  num_bihua: 'Брой черти',
  write_demo: 'Демонстрация на писане',
  vocab_side: 'Kлючове',
  level: 'Всички нива',
  see_more: 'Вижте повече',
  same_read_word: 'Хомофони',
  samilar_read_word: 'Близки по звучене',
  add_mark: 'Добавяне на отметка',
  word_team: 'Създаване на думи',
  instance: 'Примерно изречение',
  include_num_char: 'Съдържа {total} китайски йероглифа',
  length_diff: 'Дължината на пинин и йероглифите не съвпада',
  add_word_success: 'Думата е добавена успешно',
  add_word_fail: 'Неуспешно добавяне на дума',
  edit_word_success: 'Думата е редактирана успешно',
  edit_word_fail: 'Неуспешно редактиране на дума',
  del_success: 'Успешно изтриване',
  del_fail: 'Неуспешно изтриване',
  mark_free: 'Можете свободно да маркирате, например „усвоено“',
  write_word_sentence: 'Моля, съставете изречение с горните думи…',
  write_word_artical: 'Моля, напишете кратък текст с горните ключови думи…',
  write_img_artical: 'Моля, напишете кратък текст по горната снимка…',
  write_artical_title: 'Моля, въведете заглавие на статия…',
  write_artical_content: 'Моля, въведете съдържание…',
  my_wallet: 'Моите покупки',
  learn_history: 'Учебни записи',
  manage: 'Управление на потребители',
  birthday: 'Дата на раждане',
  email: 'Имейл',
  change_pw: 'Промени паролата',
  edit_info: 'Редактиране на информация',
  lastName: 'Фамилно име',
  firstName: 'Собствено име',
  gender: 'Пол',
  female: 'Жена',
  male: 'Мъж',
  non_disclosure: '不透露',
  change_avatar: 'Промяна на профилна снимка',
  preview_avatar: 'Преглед на профилната снимка',
  upload_image: 'Качване на изображение',
  change_image: 'Смяна на изображение',
  enter_old_pw: 'Моля, въведете старата парола',
  enter_new_pw: 'Моля, въведете новата парола',
  enter_new_pw_again: 'Моля, въведете новата парола отново',
  forget_pw: 'Забравена парола',
  recharge: 'Презареждане',
  left_balance: 'Наличен баланс',
  consume_log: 'Отговори на изпита',
  recharge_log: 'История на покупките',
  consume_time: 'Време на плащане',
  consume_source: 'Изразходвани ресурси',
  consume_money: 'Разход',
  total_item_log: 'Общо {total} записи',
  recharge_time: 'Време на презареждане',
  recharge_num: 'Количество за презареждане',
  recharge_money: 'Сума за презареждане',
  recharge_method: 'Метод на плащане',
  learn_content: 'Учебно съдържание',
  total_score: 'Общ резултат',
  view_result: 'Виж резултати',
  management: 'Управление на потребители',
  give_history: '赠送历史',
  total_recharge: '总计充值',
  last_login: '最后登录',
  give: 'Подаряване',
  gifted: 'Подаряване',
  give_time: '赠送时间',
  give_to_person: '授予人',
  opera_person: 'Оператор',
  give_to: '赠送给',
  old_password_empty: 'Старата парола не може да бъде празна',
  diff_password: 'Двете въведени пароли не съвпадат',
  change_pw_success: 'Паролата е успешно променена',
  change_pw_fail: 'Неуспешна промяна на парола',
  change_info_success: 'Информацията е успешно променена',
  change_info_fail: 'Неуспешна промяна на информация',
  statistics_center: 'Център за статистика',
  select_recharge_mount: 'Изберете сума за презареждане',
  waiting_pay: 'Изчаква се плащане...',
  has_no_resolve_credit: '尚未收到付款，请再次尝试购买.',
  complete_pay: 'Плащането е успешно',
  pay_fail: 'Плащането не бе успешно',
  give_success: 'Подаръкът е успешно изпратен',
  give_fail: 'Неуспешно изпращане на подарък',
  change_avatar_success: 'Профилната снимка е успешно променена',
  change_avatar_fail: 'Неуспешна промяна на профилна снимка',
  enter_family_name: 'Моля, въведете фамилия',
  enter_given_name: 'Моля, въведете име',
  log_in: 'Вход',
  log_in_error: 'Неуспешен вход',
  email_address: 'Имейл адрес',
  invalid_email_address: 'Невалиден имейл адрес',
  password: 'Парола',
  password_tip: 'Паролата трябва да е с дължина 6-20 символа',
  invalid_password: 'Невалиден формат на парола',
  have_account: 'Вече съществува акаунт {text}',
  sign_up: 'Регистрация',
  sign_up_error: '注册失败',
  forget_pw_success: 'Имейлът за нулиране на паролата е изпратен успешно',
  forget_pw_error: 'Изпращането на имейл за нулиране на паролата не бе успешно',
  loading: 'Зареждане',
  account_block: 'Акаунтът е деактивиран',
  account_block_tip: 'Моля, свържете се с администратора на Вашето училище за повече информация',
  resend_email: 'Изпрати имейла отново',
  resend_email_success: 'Имейлът е изпратен отново',
  resend_email_error: 'Неуспешно повторно изпращане на имейл',
  i_am: 'Аз съм',
  choose_role: 'Кое най-добре Ви описва',
  choose_role_error: 'Неуспешен избор на роля',
  continue: 'Продължи',
  learner: 'Студент',
  learner_description: 'Уча китайски',
  teacher: 'Учител',
  teacher_description: 'Преподавам китайски',
  setup_account_error: 'Неуспешно задаване на информацията за акаунта',
  tos_link: 'Общи условия',
  privacy_link: 'Политика за поверителност',
  email_verified: 'Имейлът е потвърден!',
  email_verified_tip: 'Благодарим за потвърждението на имейла.',
  email_verified_error: 'Вашият акаунт не може да бъде потвърден',
  something_wrong: 'Възникна грешка',
  retry: 'Опитайте отново',
  guardian_consent_error: 'Неуспешна операция',
  about_us: 'За нас',
  about_us_new: 'За нас',
  feedback: 'Свържи се с нас',
  download: 'Изтегляне',
  submit: 'Подаване',
  feedback_success: 'Подаването е успешно',
  feedback_error: 'Неуспешно подаване',
  feedback_contact_tip: 'След изпращане ще се свържем с вас своевременно чрез имейла, използван при регистрацията.',
  logout: 'Изход от акаунт',
  my_account: 'Моят акаунт',
  login_signup: 'Вход / Регистрация',
  please_enter_content: 'Моля, въведете съдържание на обратната връзка (задължително)',
  describe_detail: 'Ако описвате проблем, моля, предоставете възможно най-подробна информация',
  upload_picture: 'Качване на снимки (по избор, максимум {maxFiles} снимки. Поддържа JPG/PNG, максимум 2MB на снимка)',
  file_error: 'Грешен формат или размер на файла',
  file_num_limit: 'Максималният брой файлове за качване е {maxFiles}',
  sure_change_lang: 'Потвърждавате ли смяната на езика?',
  privacy_policy_text1: 'HSK Mock.com — Единствената официално сертифицирана платформа за пробни изпити от Han Kao International',
  privacy_policy_text2:
    'Платформата за пробни изпити е съвместно разработена и управлявана от Wo Hui и Han Kao International, базирана на базите с въпроси на HSK и YCT. Осигурява пълна подготовка с реални изпитни материали за китайските тестове.',
  privacy_policy_text3: 'Wo Hui Mandarin е официален партньор на Han Kao International.',
  privacy_policy_text4:
    'Han Kao International Education Technology (Пекин) Co., Ltd. е професионална организация за международни китайски образователни и изпитни услуги, предлагаща изследвания, разработка на технологии, изпълнение на изпити и маркетинг услуги в световен мащаб, за да отговори на нуждите на изучаващите китайски и съответните образователни институции.',
  privacy_policy_text5:
    'Основана в Сингапур през 2018 г. от EiM International Education Group, нашата независима компания е посветена на предоставянето на техническа поддръжка и платформени услуги за изучаващи китайски език по целия свят. Ние предлагаме разнообразна гама от курсове за различни ученици и огромна библиотека от учебни ресурси и практически инструменти за учители. Нашата интелигентна технология дава възможност за обучение, освобождавайки ръцете на учителите и подобрявайки учебния процес. Ние помагаме на учениците да постигнат индивидуалните си цели и ги насърчаваме да станат самостоятелни и изключителни ученици.',
  privacy_policy_text6:
    'Han Kao International и Wo Hui имат стабилно партньорство, за популяризиране и изучаване на китайски. За по-точна оценка на нивото на учениците, целенасочено обучение и симулиране на реална изпитна среда, те провеждат стратегическо сътрудничество, покривайки всички нужди на учащите.',
  level_test: 'Тест за ниво',
  level_test_example:
    'Ако не сте сигурни за нивото си, можете да направите безплатен бърз тест, за да определите подходящите цели за учене.',
  download_app_mobile: 'За по-добро преживяване използвайте десктоп версията на hskmock.com или изтеглете приложението.',
  common_video_failed: 'Неуспешно зареждане на аудио',
  member_error: 'Проблем с ресурса!',
  agree_policy:
    'Прочетох и се съгласявам с <u className="strong"><a target="_blank" href="{url}">„Условията за ползване“</a> и <a target="_blank" href="{userUrl}">„Политиката за поверителност“</a></u>',
  please_check: 'Моля, отметнете, че сте прочели и се съгласявате с „Потребителското споразумение“ и „Политиката за поверителност“.',
  media_devices_unsupported_browserLabel:
    'Препоръчва се да зададете Google Chrome като браузър по подразбиране. Пример за Windows 10: Настройки - Приложения - Приложения по подразбиране - Интернет браузър - Изберете Google Chrome',
  media_devices_help_title: 'Включване на микрофон',
  media_devices_help_content: 'Необходимо е да включите микрофона, за да запишете аудио',
  batch_exist_user: '{number} Регистрирани потребители',
  batch_and: 'и',
  batch_un_exist_user: '{number} Неинатригиран потребител',
  batch_from: 'От',
  batch_notes: 'Забележка',
  batch_something: 'Моля, попълнете',
  batch_people_number: 'Брой дариители',
  batch_use_number2: 'Расход на продукт',
  batch_operation_status: 'Състояние на работа',
  batch_ing_status: 'В процесе',
  batch_success: 'успешно',
  batch_failed: 'неуспешно',
  batch_select: 'Моля, изберете',
  common_to: 'До',
  common_start_time: 'Начална дата',
  common_end_time: 'Крайна дата',
  batch_search_tips: 'Поставете потребителски акаунти тук (разделете със запетая, може да импортирате максимум 50 потребителя на един път)',
  common_un_exist: 'Не е регистриран',
  common_invalid: 'Невалиден',
  batch_all_give: 'Купуване на тестове в големи количества',
  batch_single_people: 'индивидуален',
  batch_all: 'пакетиране',
  batch_name: 'Име',
  batch_added_credits: 'Брой подарени',
  batch_spent_credits: 'сумата на разходите',
  batch_account_status: 'Състояние на акаунта',
  batch_Added_total: 'Общо подаръци',
  batch_spent_total: 'Общо разходи',
  batch_Remaining: 'Остава',
  batch_Recipients: 'Предоставяща лице',
  batch_Active: 'Активирано',
  batch_search: 'Търсене',
  certificate_details: 'Подробности за сертификата',
  get_official_mock_certificate: 'Получи официален сертификат от пробния изпит',
  certificate_tips: 'Подробностите за сертификата са взети от Вашите лични данни. Моля, потвърдете правилността им:',
  country: 'Националност',
  select_country: 'Моля, изберете националност',
  email_to: 'Сертификатът ще бъде изпратен по имейл на:',
  polyphonic: 'Йероглифи с много произношения',
  click_tips: 'Натисни върху номера на задачата, за да видиш отговора',
  download_tips: 'Сертификатът за пробния изпит може да бъде изтеглен след успешно преминаване',
  cancel_delete_account: 'Отпиши акаунта',
  cancel_confirm: 'Потвърди',
  user_apply_delete_account_title: 'Заявка за изтриване на акаунт',
  user_apply_delete_account_confirm_tip: 'Потвърдете Вашата информация за вход',
  user_apply_delete_account_alwaysTip: 'В момента искате да изтриете окончателно Вашия акаунт и свързаните лични данни.',
  user_apply_delete_account_confirm_tip2: 'Моля, потвърдете самоличността си преди подаване на заявката.',
  user_apply_delete_account_desc:
    'Вашият акаунт {email} се използва за вход и достъп до <a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> и <a href="{mockLink}" target="_blank">HSK Mock</a>',
  user_apply_delete_account_desc2: 'След изтриване, този акаунт вече няма да може да се използва за вход в горепосочените приложения.',
  user_apply_delete_account_wohui_title: 'Отказване на абонамент Wo Hui',
  user_apply_delete_account_hsk_title: 'Баланс HSK MOCK',
  user_apply_delete_account_next_tip: 'Натиснете „Напред“, за да потвърдите, че сте прочели и сте съгласни с горепосоченото.',
  user_apply_delete_account_next_title: 'Напред',
  user_apply_delete_account_confirm_tip11: 'След анулиране на абонамента можете да продължите с изтриването на акаунта',
  cancel_delete_ok: 'Добре',
  cancel_delete_request_send: 'Изпращане на заявка',
  user_apply_delete_account_confirm_tip8: 'Когато абонаментът Ви изтече на {date}, акаунтът Ви ще бъде изтрит окончателно',
  user_apply_delete_account_confirm_tip4: 'Ще изпратим имейл до',
  user_apply_delete_account_confirm_tip5: 'за потвърждение, че акаунтът Ви е изтрит',
  user_apply_delete_account_confirm_tip6: 'За отказ на заявката натиснете „Отказ“',
  user_apply_delete_data_always: 'Искате ли да отмените заявката за окончателно изтриване на акаунта и свързаните данни?',
  cancel_delete_yes: 'Потвърждение',
  cancel_delete_no: 'Отказ',
  user_cancel_delete_success: 'Вашата заявка е отменена, акаунтът Ви в HSK Mock няма да бъде изтрит.',
  user_cancel_subscribe_again: 'Можете да се абонирате отново.',
  user_apply_delete_account_confirm_tip9: 'Краен срок на абонамента',
  user_apply_delete_account_confirm_tip10: 'Моля, изберете времето за изтриване на акаунта',
  user_apply_delete_account_ok_btn_title: 'Краен срок на абонамента',
  user_apply_delete_account_now_btn_title: 'Изтриване веднага',
  cancel_out_subscription_abnormal: 'Проблем с информацията за абонамента',
  user_apply_delete_account_confirm_tip3:
    'Имате абонамент в Apple, таксите ще се начислят автоматично, моля отменете преди подновяване',
  user_apply_delete_stripe_tip:
    'Вашият абонамент Stripe автоматично ще бъде таксуван чрез вашата кредитна/дебитна карта. Моля, посетете нашия сайт.',
  user_apply_delete_account_balance: 'Баланс на Вашия акаунт',
  user_apply_delete_account_balance_tip: 'След изтриване, балансът няма да бъде възстановен.',
  user_apply_delete_account_expire: 'Вашият акаунт ще бъде изтрит в рамките на три дни',
  my_class_name: 'Моят клас',
  my_class_search: 'Търсене на клас',
  my_class_total: 'Общо',
  my_class_people: 'Човек',
  my_class_ci: 'Брой посещения',
  my_class_number: 'Брой хора',
  my_class_ci_number: 'Брой пъти',
  my_class_tips: 'Вътрешен кръг: Процентно разпределение HSK и YCT',
  my_class_tips1: 'Външен кръг: Процентно разпределение на различните нива HSK и YCT',
  my_class_all_class: 'Всички класове',
  follow_lesson: 'Виж курс',
  real_paper: 'Провеждане на пълен пробен тест',
  start_answer: 'Започване на отговори',
  edit_message_date: 'Дата',
  edit_message_language: 'Език',
  edit_message_zh: 'Китайски',
  edit_message_en: 'Английски',
  edit_message_title: 'Заглавие',
  edit_message_content: 'Моля, въведете основния текст',
  edit_message_show: 'Показване',
  edit_message_save_success: 'Запазването е успешно!',
  edit_message_create_success: 'Успешно добавено!',
  edit_message_edit1: 'Редактиране',
  edit_message_follow_notice: 'Преглед на известията',
  edit_message_textarea_tips: 'Ако добавяте линкове, моля, поставете интервал след всеки линк, за да ги разделите',
  edit_message_notifications: 'Редактиране на известие',
  edit_message_Send_time: 'Време на изпращане',
  edit_message_edit_notification: 'Редактиране на известие',
  edit_message_add: 'Добавяне на известие',
  edit_message_from: 'Начално време',
  edit_message_to: 'Крайно време',
  edit_message_new_add: 'Добавяне на известие',
  currency: 'Избор на валута',
  pay_failed: 'Страницата не се зареди успешно?',
  pay_un_finished: 'Плащането не може да бъде завършено',
  select_currency_tips: 'Ако желаете, можете да изберете различна валута от падащото меню по-долу',
  change_currency_tips: 'Можете по всяко време да промените валутата в „Моят акаунт“.',
  my_homework: 'Моите задачи',
  my_homework_add: 'Възлагане на задачи',
  my_homework_all_classes: 'Всички класове',
  my_homework_paper: 'Име на изпитния лист',
  my_homework_sent_to: 'Изпращане',
  my_homework_sent_on: 'Време на изпращане',
  my_homework_due_on: 'Краен срок',
  my_homework_submitted_assignees: 'Брой подадени/Брой изпратени',
  my_homework_class_hint: 'Иконата около името на класа означава, че е възложена само на част от учениците',
  my_homework_delay_hint: 'Показване на разрешение за предаване на задачи след определената крайна дата и час',
  my_homework_add_send_assignment: 'Изпрати домашна работа',
  my_homework_add_new_assignment: 'Публикуване на домашно задание',
  my_homework_edit_assignment: 'Редактиране на задача',
  my_homework_add_assignment: 'Добавяне на задача',
  my_homework_add_assignment_details: '1.Подробности за домашната работа',
  my_homework_add_issue_time: 'Време на публикуване',
  my_homework_add_whether_submit: 'Разрешаване на предаване след крайния срок',
  my_homework_add_note: 'Бележки',
  my_homework_add_assignees: '2.Получатели',
  my_homework_edit_add_assignees: 'Получатели',
  my_homework_add_group: 'Изберете курс',
  my_homework_add_immediate_release: 'Публикувай веднага',
  my_homework_add_time_release: 'Планирано публикуване',
  my_homework_add_are: 'Да',
  my_homework_add_no: 'Не',
  my_homework_detail_back: 'Назад към моите домашни',
  my_homework_detail_sent_to: 'Изпрати до',
  my_homework_detail_leamers_in: 'ученици в',
  my_homework_detail_on: 'в',
  my_homework_detail_to_complete_by: 'Изпращането е завършено в',
  my_homework_detail_add_assignee: 'Добави получател',
  my_homework_detail_assignee: 'Получатели',
  my_homework_search_placeholder: 'Моля, въведете текст за търсене',
  my_homework_stu_sent_by: 'Изпратил',
  my_homework_total_topic_count: 'Общо {count} въпроса',
  my_homework_time_full: '{min} минути',
  my_homework_select_date_time: 'Избери дата и час',
  my_homework_delete_assignment_title: 'Изтриване на домашна работа',
  my_homework_delete_assignment_tips: 'Сигурни ли сте, че искате да изтриете домашната работа? Изтриването не може да бъде отменено!',
  my_homework_assignment_add_fail: 'Публикуването неуспешно!',
  my_homework_assignment_add_success: 'Публикуването успешно!',
  my_homework_assignment_edit_success: 'Редактирането успешно!',
  my_homework_assignment_edit_fail: 'Редактирането неуспешно!',
  my_homework_assignment_delete_fail: 'Изтриването неуспешно!',
  my_homework_assignment_delete_success: 'Изтриването успешно!',
  my_homework_assignment_due_on: 'Краен срок',
  my_homework_assignment_product: 'Име на продукта',
  my_homework_assignment_certificate: 'сертификат',
  my_homework_assignment_reset: 'Нулиране',
  my_homework_assignment_reset_title: 'Да се нулира ли избраният модул?',
  my_homework_assignment_gifted: 'Брой подарени',
  my_homework_assignment_papers: 'брой тестове',
  my_homework_assignment_send_to: 'Домашната работа е изпратена до',
  my_homework_assignment_close_tip: 'Текущото изпращане на домашната работа не е запазено. Сигурни ли сте, че искате да излезете?',
  pay_callback_tips:
    'Ако сте в материкова Китай, но не сте китайски гражданин, препоръчваме ви да използвате Visa или Master карта. Работим над решението, което ще поддържа вашето WeChat, Alipay и UnionPay карти.',
  no_available_class: 'Няма налични класове за избор',
  payment_method: 'Метод на плащане',
  wechat_pay: 'Плащане с WeChat',
  alipay_payment: 'Плащане с Alipay',
  card_payment: 'Кредитна карта',
  card_payment_description: 'Само чуждестранни банкови карти',
  payment_to_wohui: 'Плащане към 我会我汇我慧科技（上海）有限公司',
  order_submitted: 'Поръчката е успешно подадена. Моля, извършете плащането възможно най-скоро!',
  order_number: 'Номер на поръчка:',
  code_expires:
    'QR кодът ще изтече след <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
  use_weChat: 'Моля, използвайте WeChat, за да сканирате QR кода и извършите плащането',
  code_expired: 'Текущият QR код е невалиден',
  amount_payable: 'Дължима сума：',
  use_code: 'Използвай код за достъп',
  tests: 'Изпитни записи',
  level_title: 'Kъм кое ниво се стремите?',
  level_des:
    'Aко не сте сигурни, може да направите един<b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">безплатен тест за оценка на нивото</b>',
  level_HSK_text1: '<b>HSK</b> е пинин съкращението на „中文水平考试“, което означава тест за нивото по китайски език.',
  level_HSK_text2: 'Това е най-популярният тест по китайски език в света.',
  level_YCT_text1: '<b>YCT</b> е английското съкращение на „中小学生中文水平考试“,',
  level_YCT_text2: 'То означава тест по китайски език, предназначен за ученици от начални и средни училища.',
  level_PRIMARY: 'Начално ниво',
  level_BEGINNER: 'Начално ниво',
  level_INTERMEDIATE: 'Средно ниво',
  level_ADVANCED: 'Високо ниво',
  level_dialog_title: 'Тест за ниво',
  level_dialog_content:
    'Безплатният тест за определяне на нивото отнема около 15 минути и показва какво HSK ниво си достигнал, както и колко близки са уменията ти по слушане, четене, писане и говорене до това ниво.',
  level_dialog_login: 'Вход / Регистрация',
  level_dialog_start: 'Стартирай теста за определяне на нивото',
  about_us_first_paragraph:
    '<b>HSK Mock</b> е най-популярният в света изпит по китайски език и единствената официална платформа за пробни изпити по HSK и YCT. Платформата е съвместен продукт на <b>Hanban International</b> и <b>Wo Hui Chinese</b>.',
  about_us_second_paragraph:
    '<b>Hanban International</b> (CTI) е изпитната комисия за HSK и YCT. Това е дружество с ограничена отговорност със седалище в Пекин, което, чрез предлагане на редица услуги на физически лица и институции, насърчава и подкрепя изучаването, преподаването и тестването на китайски като чужд език в световен мащаб.',
  about_us_third_paragraph:
    '<b>Wo Hui Chinese</b> (Wo Hui) предоставя официалната онлайн платформа за курсове и изпити по HSK и YCT. Това е дружество с ограничена отговорност със седалище в Сингапур, което чрез технологии дава свобода на учениците да учат самостоятелно и овластява преподавателите да предоставят необходимата подкрепа в индивидуалното учебно пътешествие на учениците.',
  about_us_cti_text: 'Научете повече:',
  about_us_wohui_text: 'Ако желаете да научите повече, моля свържете се:',
  listening_section: 'Част по слушане',
  reading_section: 'Част по четене',
  writing_section: 'Част по писане',
  review_answers: 'Проверка на отговорите',
  characters_long: 'Ако все още нямате акаунт, задайте парола с дължина между 6 и 20 символа.',
  complete_profile: 'Попълни личния профил',
  verify_email: 'Потвърдете Вашия имейл',
  link_sent: 'Благодарим  за регистрацията. Моля, кликнете върху връзката, която Ви изпратихме, за да потвърдите дали това е правилният ви имейл адрес:',
  resend_link: 'Изпрати връзката отново >',
  restart: 'Рестартирай',
  parental_consent: 'Информираност на родителите',
  sent_parental: 'Благодарим Ви за регистрацията. Моля, следвайте инструкциите в имейла, който ви изпратихме, за да получите съгласието на Вашите родители или настойници:',
  thank_you: 'Благодарим!',
  or_return: 'Или се върни към приложението',
  child_profile: 'Профил на Вашето дете',
  sign_up_privacy:
    'Прочетох и се съгласявам с <a class="link" target="_blank" rel="noopener noreferrer" href="{url}">„Условията за ползване“</a> и <a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">„Политиката за поверителност“</a>',
  give_consent: 'Съгласен/на съм',
  delete_child_details: 'Изтрий информацията на детето',
  account_created: 'Акаунтът е създаден успешно',
  emailed_know: "Изпратихме имейл на <span style='font-weight: 700'>{email}</span>, за да ги уведомим.",
  account_deleted: 'Изтрий акаунта',
  child_know_deleted: 'Моля, уведомете детето си, че информацията му е изтрита.',
  request_email:
    'Цялата информация по-горе (с изключение на имейл адреса) може да бъде актуализирана след влизане. Моля, дайте съгласие детето Ви да създаде акаунт или поискайте изтриване на техните данни.',
  preferred_currency: 'Предпочитана валута',
  parent_guardian: 'Родител/настойник',
  class_name: 'Име на класа',
  // start
  tofficial_platform: 'Единствената официална платформа за пробни изпити по HSK',
  tofficial_platform_new: 'HSK Официална платформа за пробни изпити',
  proficiency_tests: 'Подготовка за най-популярния в света изпит по китайски език',
  proficiency_tests_new: 'Комбинира реални изпитни материали, професионално оценяване, засилване на лексиката и интелигентни упражнения – за ефективна подготовка.',
  get_started: 'Започни',
  get_started_new: 'Започни',
  start_practicing: 'Започни упражненията',
  get_ready: 'Подготви се за HSK – започни още сега!',
  real_hsk_exam_content: 'Реални изпитни материали',
  real_hsk_exam_desc: 'Упражнявай се с реални изпитни тестове, подготви се ефективно и се яви с увереност.',
  official_level_scoring: 'Професионално оценяване',
  official_level_scoring_desc: 'Оценяване според официалните стандарти на HSK – надеждни и точни резултати.',
  vocabulary_boost: 'Усилено изучаване на лексика',
  vocabulary_boost_desc: 'Използвай безплатни карти с думи и интелигентни упражнения, за да запомниш лесно всяка дума!',
  get_hsk_ready: 'Пълноценен гид за подготовка за HSK',
  how_it_works: 'Как да използваш платформата',
  choose_your_level: 'Избери ниво',
  choose_your_level_desc: 'Избери подходящото ниво за изпита – от HSK Ниво 1 до Ниво 9.',
  practise_and_learn: 'Обучение и тестване',
  practise_and_learn_desc: 'Започни с безплатно трениране на думи! С надграждане на акаунта ще отключиш пълни официални HSK пробни тестове и интелигентно оценяване.',
  track_your_progress: 'Проследявай напредъка си',
  track_your_progress_desc: 'След всеки тест виж резултатите по секции, следи развитието си и планирай ефективно подготовката си.',

  got_questions: 'Имаш въпроси? Отговорите са при нас.',
  faq: 'Често задавани въпроси',
  faq_desc: 'Относно подготовката за HSK и платформата HSK Mock.',
  faq_btn: 'Виж ЧЗВ',

  blog: 'Блог',
  blog_desc: 'Разгледай нашия блог за полезни съвети за подготовка за HSK.',
  blog_btn: 'Разгледай блога',

  contact: 'Свържи се с нас',
  contact_desc: 'Нуждаеш се от персонализирана помощ? Обърни се към нашия екип за обслужване на клиенти.',
  contact_btn: 'Свържи се с нас',

  mock_tests: 'Пробен изпит',
  blog_and_faq: 'Блог и ЧЗВ',
  real_results_from_real_learners: 'Реална обратна връзка, реални резултати',
  support: 'Помощ и поддръжка',
  choose_your_hsk_level: 'Избери своето HSK ниво',
  choose_your_hsk_level_desc: 'Подготви се за HSK, HSK Устен и YCT с официални пробни изпити и интелигентни инструменти.',

  hsk_levels: 'HSK',
  hsk_speaking: 'HSK Устен изпит',
  yct: 'YCT',
  // hsk3.0
  hsk_levels_tri: 'New HSK',

  start_learning: 'Започни да учиш сега!',
  for_institutions: 'Училища и различни образователни организации',

  for_hsk3_condidates: 'За кандидати по HSK 3',
  for_hsk4_condidates: 'За кандидати по HSK 4',
  for_hsk56_condidates: 'За кандидати по HSK 5-6',
  // end
  platform_china: 'Този платформа също помага и на кандидатите от материка на Китай.',
  take_confidence: 'Бъди сигурен когато се явяваш на HSK',
  practice_tests: 'Практика за HSK и YCT',
  using_time:
    'Използвайте най-новите официални изпитни материали, за да се запознаете с различните типове задачи, овладеете изискванията, ускорите решаването и успешно завършите изпита.',
  instant_results: 'Навременна обратна връзка',
  each_test_question:
    'Прегледайте всяка решена задача: виждате резултата си, подробности за решаването и правилния отговор. Така ще знаете къде грешите, ще коригирате слабостите си и ще вървите към успех.',
  track_progress: 'Проследяване на напредъка',
  ready_next_test:
    'Платформата автоматично записва датата и часа на всяка Ваша пробна сесия, както и развитието и резултатите. Тези данни ще Ви покажат кога е най-подходящият момент да се явите на истинския изпит, за да постигнете най-добър резултат.',
  receive_official_certificates: 'Получаване на официален сертификат за пробен изпит',
  certificates_provide_evidence:
    'За всяка успешно премината пробна сесия получавате сертификат, доказващ, че вече притежавате определено ниво по китайски.',
  ready_next_level: 'Следваща стъпка',
  check_description:
    'Прегледайте изискванията за следващото ниво, повторете нужната лексика, вижте структурата на изпита и усвоете необходимите техники.',
  on_the_move: 'Използване на мобилно приложение?',
  on_the_move_new: 'Изтегли приложението HSK Mock,',
  download_mobile: 'Кликнете върху бутона по-долу, за да изтеглите мобилното приложение.',
  download_mobile_new: 'се подготвяй навсякъде и по всяко време.',
  footer: 'HSK Mock е официална платформа за пробни изпити HSK, която комбинира реални тестове, професионално оценяване, засилено лексикално обучение и интелигентни упражнения.',
  hsk_beginner_advanced:
    '<span style="font-weight: 700">HSK</span> е пинин съкращението на „中文水平考试“, което означава тест за нивото по китайски език.Това е най-популярният тест по китайски език в света.Има общо 9 нива – от начално до високо.',
  more: 'Oще >',
  more_menu: 'Научете повече',
  ytc_beginner_advanced:
    "<span style='font-weight: 700'>YCT</span> е английското съкращение на „中小学生中文水平考试“,То означава тест по китайски език, предназначен за ученици от начални и средни училища.Има 4 нива – от начално до средно.",
  coming_end: 'В края на 2023 г. стартира и устният пробен изпит.',
  candidates_proficiency_speaking: 'Това е тест, който проверява способността на кандидатите да говорят китайски.',
  level_oral_tests:
    "<span style='font-weight: 700'>HSKK</span> е съкращение от „中文水平口语考试“, което означава тест за китайски език.",
  check_test_dates: 'Изпитни дати',
  book_test: 'Регистрация за изпит',
  international_platform:
    'Китайската платформа се намира в континентален Китай; Международната платформа се намира в Сингапур. Двете платформи са независими една от друга. Моля изберете подходящата за вас платформа.',
  mock_platform: 'Официална платформа за пробни изпити',
  home_proficiency_tests: 'Подготовка за най-популярния тест по китайски език',
  currency_type: 'Избор на валута',
  Pick_your_level: 'Изберете своето ниво',
  About_this_level: 'Представяне на нивата',
  test_session: 'за тест',
  Learning_resources: 'Учебни ресурси',
  Take_practice_test: 'Пробен изпит',
  Compare_syllabuses: 'Сравни учебните програми',
  table_shows_syllabuses: 'Таблицата показва нивата на HSK според различните учебни програми.',
  forrgin_lang: '0547 – „Китайски като чужд език“',
  Second_Language: '0523 – „Китайски като втори език“',
  Requirement_entry: 'Изисквания за регистрация',
  most_Chinese_universities: 'Повечето китайски университети',
  Qing_Hua: 'Университета "Цинхуа"',
  beijing_university: 'Пекинския университет',
  working_towards: 'Препоръчително ниво на подготовка след теста',
  On: 'в',
  Level_test: 'Тест за ниво',
  Retake_level_test: 'Повтори теста',
  practice_test: 'Участвай в един пробен изпит',
  Compare_syllabuses_a: 'Сравнение между различни учебни програми и HSK стандарта',
  Not_sure: 'Не си сигурен в нивото си?',
  free_level_test: 'Направи безплатен тест за определяне на нивото',
  Examples: 'Примерни задачи',
  product_code: 'Код за достъп',
  enter_paper: 'Въведете кода за размяна, за да участвате в теста',
  no_code: 'Нямаш код? Купи от нашите партньори:',
  to_partner: 'Посети партньорския сайт',
  code_here: 'Въведи своя код тук',
  start_assigment: 'Старт',
  view_assigment: 'Преглед на резултатите',
  continue_assigment: 'Продължи',
  choose_method: 'Избери начин за отключване',
  choose_new_method: 'Моля, избери метод за отключване на нов тест.',
  browser_layer: 'Моля, използвайте браузъра Google Chrome на компютър или приложението на мобилно устройство',
  partner_title1: 'Надяваме се имате интерес да се превърнете в',
  partner_title2: 'местен партньор',
  company_name: 'Име на компанията',
  company_website: 'Уебсайт на компанията',
  teachers_count: 'Брой HSK преподаватели, с които работите',
  learners_count: 'Брой HSK ученици, с които работите',
  add_msg: 'Добре дошли да ни оставите съобщение',
  contact_style: 'Как да се свържем с вас?',
  send: 'Изпрати',
  partner_forms_desc:
    'Като наш местен партньор, Вие ще бъдете основният контакт за кандидатите, преподавателите, началните и средните училища и университетите във Вашата държава или регион.<br><br>Нашите партньори обикновено са утвърдени центрове за изпити и обучение по HSK, които желаят да разширят дейността си и да повишат официалното си признание.<br><br>Ако искате да станете наш местен партньор, първо използвайте личен HSK пробен акаунт, за да <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">влезете</span>, и попълнете следната информация. Ще се свържем с Вас възможно най-скоро.',
  submit_success: 'Изпращането е успешно',
  help_students_for_testing: 'Имате ли в момента ученици, на които помагате да се подготвят за изпит?',
  help_students_for_testing_desc:
    'Преподавателите играят решаваща роля за това учениците да постигнат следващата си цел. <br>HSK Mock предоставя на учителите инструменти за индивидуална подкрепа.',
  become_partner: 'Станете наш местен партньор.',
  become_partner_desc:
    'За кандидатите е удобно да се свържат на родния си език с местния изпитен център и да използват предпочитан начин на плащане.',
  partnership: 'Обсъдете възможно сътрудничество',
  students_forward: 'Подкрепи своите ученици',
  hsk_confidence: 'Дай им увереност за HSK изпита',
  try_it_out: 'Изпробвай сега',
  walk_through: 'Запознай учениците с изпитния процес',
  teachers_page_desc1:
    'Функциите на платформата поддържат както групово, така и индивидуално обучение. Учениците ще се запознаят с различните типове задачи, ще преговарят лексиката, ще разгледат съдържанието на изпита и ще усвоят нужните техники.',
  assign_practice_papers: 'Задай краен срок и час за предаване',
  teachers_page_desc2:
    'Публикувай пробния тест за учениците си. Можеш да използваш теста като реален изпит, за да им помогнеш да свикнат с различните типове задачи и да ги завършат в определеното време.',
  get_instant_results: 'Незабавна обратна връзка за резултатите',
  teachers_page_desc3:
    'Без ръчна проверка от учител. Виж дали учениците са приключили теста и прегледай техните резултати.',
  review_their_answers: 'Преглед на отговорите на учениците',
  teachers_page_desc4:
    'Анализирай резултатите по клас, умение, секция или въпрос. Това ти позволява да създадеш точен учебен план и да дадеш персонализирана обратна връзка.',
  track_prog: 'Проследяване на напредъка',
  teachers_page_desc5:
    'Подробен запис на всеки резултат от тест, с информация за отговорите на всяка задача и развитието на уменията. Тези данни помагат на учителя да определи най-подходящия момент за явяване на официалния изпит.',
  students_next_level: 'Изведи учениците на следващо ниво',
  teachers_page_desc6:
    'Нашата партньорска платформа предлага официални материали за HSK и YCT, както и всички нужни инструменти и ресурси, за да подкрепиш учениците индивидуално.',
  teaching_resources: 'Учебни ресурси',
  for_teachers: 'Учители',
  teachers_desc1:
    'Моля, първо <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">влез</span> в платформата за пробни изпити HSK Mock с личния си акаунт.',
  teachers_desc2: 'Попълнете основната информация по-долу, за да активираме безплатен пробен достъп за Вашето училище.',
  school_name: 'Име на училището',
  school_web: 'Уебсайт на училището',
  num_of_hsk_teachers: 'Брой HSK учители',
  num_of_hsk_learners: 'Брой HSK ученици',
  hsk_submit_reading: 'Четене',
  pay_tip: 'Ако си платил чрез Alipay или WeChat, моля използвай китайския сайт hskmock.cn',
  use_pc_or_app: 'Изпробвай сега, Моля, влезте от компютъра си или изтеглете нашето приложение.',
  download_certificate: 'Изтегляне на сертификат',
  create_certificate: 'Генериране на сертификат',
  certificate_is_downloaded: 'Сертификатът е изтеглен',
  pay_discount_title: 'Колко пъти искате да закупите реален пробен изпит за {level}?',
  total: 'Общо',
  pay: 'Плащане',
  price_desc:
    'Необходимо е да заплатите само за пробния изпит. Ако закупите няколко изпита наведнъж, ще получите отстъпка.',
  the_level: 'Ниво',
  discounted_price: 'Цена',
  price_contact_us:
    'Ние предлагаме и услуги за групови покупки за училища и организации. <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">Свържете се с нас</span>, за да обсъдим Вашите конкретни нужди。',
  get_a_discount: 'Получаване на отстъпка',
  finished_pay_discount_title: 'Towa e Вашият код за достъп до реалния пробен изпит за {level_name}.',
  btn_goto_papers: 'Преглед на изпитния лист за {level_name}',
  test_count: '{test_num}тест',
  unit_price: '{price}/тест',
  buy_code_tip:
    'Ние вече сме изпратили тези кодове по имейл. Просто изберете изпитния лист за {level_name}, който искате да направите, въведете кода и го отключете.',
  discount_codes_left_tip:
    'След края на теста ще Ви останат <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count}</span> кода за това ниво.',
  manage_class: 'Управление на класове',
  to_manage_class: 'Системата за управление на класове ще се отвори в нов раздел. След като приключите, върнете се в този раздел и опреснете страницата。',
  code_used: 'Използвани',
  code_can_be_used: 'Неизползван',
  no_test: 'Количество',
  history_purchase_quantity: 'Количество',
  hsk_listen_part_title: 'Слушане част {count}',
  hsk_read_part_title: 'Четене част {count}',
  hsk_write_part_title: 'Писане част {count}',
  Description: 'Въведение',
  Test_format: 'Форма на изпита',
  Vocabulary: 'Лексика',
  vocab_type: 'Част на речта',
  sso_login_signup: 'Вход / Регистрация',
  sso_email_address: 'Имейл адрес',
  sso_password: 'Парола',
  sso_characters_long: 'Ако все още нямате акаунт, задайте парола с дължина между 6 и 20 символа.',
  sso_forget_pw: 'Забравена парола',
  sso_agree_policy:
    'Прочетох и се съгласявам с <u class="strong"><a href="{url}" target="_blank">„Потребителското споразумение“</a></u> и <u class="strong"><a href="{userUrl}" target="_blank">„Политиката за поверителност“</a></u>.',
  sso_continue: 'Продължи',
  sso_please_check: 'Моля, отметнете, че сте прочели и се съгласявате с „Потребителското споразумение“ и „Политиката за поверителност“.',
  sso_invalid_email_address: 'Невалиден имейл адрес',
  sso_invalid_password: 'Невалиден формат на паролата',
  sso_loading: 'Зареждане',
  sso_mock_platform: 'Официална платформа за пробни изпити',
  sso_home_proficiency_tests: 'Подготовка за най-популярния тест по китайски език',
  sso_guardian_consent_error: 'Неуспешна операция',
  sso_forget_pw_success: 'Имейлът за нулиране на паролата е изпратен успешно',
  sso_forget_pw_error: 'Изпращането на имейл за нулиране на паролата не бе успешно',
  sso_log_in_error: 'Неуспешен вход',
  sso_download_app_mobile: 'За по-добро изживяване, използвайте десктоп версията на hskmock.com или изтеглете приложението.',
  sso_no_binding_info_tip: 'Неуспешно извличане на Вашата информация',
  sso_third_login_tip: 'Моля, изберете сайт за отваряне',
  sso_third_login_wohui: 'Към Wo Hui Mandarin',
  sso_third_login_mock: 'Към HSK Mock',
  other_gender: 'Поверителност / Друго',
  hsk_enter_listening: 'Слушане',
  intro_msg_first: 'Този изпит съдържа общо {num} части, които трябва да бъдат завършени последователно.',
  intro_msg_second: 'Моля, завършете всяка част в рамките на определеното време.',
  intro_msg_third:
    'Ако вече сте завършили въпросите от тази част, но крайният срок все още не е настъпил, можете да преминете към следващата част на теста, но няма да можете да се върнете към предишната част, за да продължите с отговорите.',
  dialogue_listening: 'Първата част е изпитът по слушане. Моля, натиснете бутона, за да пуснете тестовия аудио файл по-долу, и при необходимост настройте Вашето устройство.',
  dialogue_listening_hskk: 'Моля, натиснете бутона, за да пуснете тестовия аудио файл по-долу, и при необходимост настройте Вашето устройство.',
  dialogue_intro_msg_first:
    'По време на възпроизвеждането на музиката ще чуете общо въведение за изпита. Междувременно можете да прегледате въпросите от раздела по слушане.',
  dialogue_intro_msg_first_hskk:
    'По време на възпроизвеждането на музиката ще чуете общо въведение за изпита.',
  dialogue_intro_msg_second: 'За да се симулира реален изпит, не можете да спирате, превъртате назад или напред аудиото в частта по слушане.',
  dialogue_intro_msg_second_hskk: 'За да се симулира реален изпит, Не можете да спрете, възпроизвеждате или ускорявате。',
  dialogue_intro_msg_third: 'След края на аудиото за слушане ще имате {duration} минути, за да проверите своите отговори.',
  dialogue_intro_question: 'Имате проблем?',
  dialogue_preload_intro_first: 'Аудиото за частта по слушане се изтегля.',
  dialogue_preload_intro_second: 'След като изтеглянето приключи, аудиото ще се възпроизведе автоматично и изпитът ще започне.',
  dialogue_preload_intro_third: 'Желаем Ви успех!',
  dialogue_preload_title: 'Изтегляне на изпитните ресурси',
  mock_paper_preview: 'Преглед на примерен тест',
  dialogue_mock_paper_intro_title: 'Инструкции за изпита',
  dialogue_mock_paper_intro_sentence1:
    'Този изпит продължава приблизително {minutes} минути. Моля, уверете се, че разполагате с достатъчно време и батерия на компютъра, за да завършите изпита наведнъж.',
  dialogue_mock_paper_intro_sentence2: 'Изпитът се провежда изцяло онлайн, затова се уверете, че имате стабилна интернет връзка.',
  dialogue_mock_paper_intro_sentence3:
    'Ако използвате настолен компютър или лаптоп, моля, използвайте най-новата версия на браузъра Chrome или Safari.',
  dialogue_mock_paper_intro_sentence4:
    'Ако използвате таблет, моля, използвайте нашето мобилно приложение, а не уеб браузър.',
  dialogue_mock_paper_intro_sentence5:
    'По време на изпита не отваряйте други прозорци на браузъра или мобилни приложения, не сменяйте езика и не включвайте/изключвайте други устройства (като USB памет, слушалки и др.).。',
  diologue_mock_paper_quit: 'Изход',
  dialogue_mock_paper_intro_button: 'Прочетох и съм запознат',
  deadline_passed: 'Крайният срок е изтекъл',
  mock_skip_introduction: 'Пропускане на инструкциите?',
  Listening: 'Слушане',
  Reading: 'Четене',
  Writing: 'Писане',
  personal_info_display_name_as: 'Име, което ще се показва на сертификата',
  code_pratice_text: 'Използване на <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> за симулация на <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span> изпит',
  code_input_text: 'Въведете код за осребряване:',
  use_code_limit: 'Лимитът на всеки код за размяна се използва веднъж',
  code_select_text: 'Или изберете код за осребряване:',
  pay_discounts_desc1: 'Практиката с реални изпитни варианти от предходни години може да Ви помогне',
  pay_discounts_desc2: 'Желаем Ви отличен успех на изпита [{type}] [{level}]',
  pay_discounts_desc3: 'Купи едно, получи едно безплатно',
  pay_discounts_desc4:
    'Ако вече сте се регистрирали за официалния изпит [{type} {level}], при закупуване на пробен тест [{type} {level}] можете да се възползвате от промоцията Купи едно, получи едно безплатно . ',
  pay_discounts_desc5: 'Колко пробни теста желаете да закупите?',
  level_HSKK_text1: 'Изпитът HSK Устен оценява устните умения по китайски език на кандидатите. Той включва три нива – начално, средно и високо.',
  level_HSKK_text2: 'HSK устният изпит се провежда под формата на аудиозапис.',
  level_HSKK_text3: 'Кандидатите за HSK 3 трябва да преминат HSKK – начално ниво, кандидатите за HSK 4 трябва да преминат HSKK – средно ниво, а кандидатите за HSK 5 и 6 трябва да преминат HSKK – високо ниво.',
  test_download_desc: 'Пробният тест за това ниво е в процес на подготовка. Междувременно, моля изтеглете:',
  speaking: 'Говорене',
  Traduction: 'Превод',
  my_homework_none_homework: 'Това ниво временно не поддържа задаване на пробни изпити. Очаквайте скоро.',
  my_class_none_test: 'Това ниво временно не поддържа онлайн решаване на пробни тестове. Очаквайте скоро.',
  hsk_audio_error: 'Вашата интернет връзка е нестабилна, аудиото не можа да се зареди. Моля, опитайте отново.',
  mock_join_campus_text1: 'Желаете ли да приемете поканата и да се присъедините към тази общност за преподаване, учене, симулиране и изпитване по китайски език?',
  mock_join_campus_text2: 'След присъединяването учителите могат да Ви възлагат тестове чрез HSKMock.com или упражнения чрез app.wohuimandarin.com.',
  sso_join_campus_text4: 'Учителите могат да преглеждат Вашите отговори, за да предоставят целенасочена обратна връзка.',
  join: 'Присъединяване',
  free_practice_title: 'Безплатна практика',
  choose_free_practice: 'Изберете метод за упражнение',
  word_flashcards: 'Карти с думи',
  word_practice: 'Упражнения с думи',
  analyse_text: 'Анализ на текста',
  flashcards_title: 'Карти за запаметяване',
  practice_exercises_title: 'Практически задачи',
  analyse_title: 'Анализ',
  practice_result_title: 'Резултати от упражнението',
  generate_flashcards: 'Генериране на комплект карти',
  generate_practice: 'Генериране на комплект упражнения',
  random_select: 'Случаен избор',
  manual_select: 'Ръчен избор',
  max_words: 'Най-много {number} думи',
  already_choose: 'Избрани: {total}',
  free_practice_words_quantifier: 'бр.',
  // 产品确认错误提示
  free_practice_unchoose_question: 'Моля, изберете тип въпрос',
  free_practice_unchoose_practice: 'Моля, изберете тип упражнение',
  none_mark_words_hint: 'На текущото ниво нямате маркирани думи',
  excceed_max_count: 'Може да изберете до {total} думи, достигнахте лимита',
  free_practice_sound: 'Звук',
  free_practice_question: 'Въпрос',
  free_practice_choose_exercise: 'Изберете тип упражнение',
  free_practice_exercise_select: 'Еднозначен избор',
  free_practice_exercise_Pairs: 'Съчетаване (matching)',
  free_practice_exercise_TF: 'Изберете вярно (T) / грешно (F)',
  launch: 'Старт',
  free_practice_check_text: 'Отговорихте ли правилно?',
  free_practice_timer_pause: 'Пауза на таймера',
  free_practice_timer_pause_desc: 'Ако не се засече активност, таймерът ще се постави на пауза автоматично',
  free_practice_seconds: '{number} секунди',
  resume: 'Рестартиране',
  flashcard_completed: 'Практиката с карти е завършена',
  practice_completed: 'Практиката с думи е завършена',
  practice_spent_minutes: 'Общо време: {duration} минути',
  practice_result_summary: 'Обобщение на резултатите',
  practice_result_progress_txt: 'Вие получавате',
  practice_wrong: 'Грешки',
  practice_skip: 'Пропуснати',
  practice_done: 'Завършено',
  analyse_desc_1: 'Анализ на избраните думи от текста',
  analyse_desc_2: 'Поставете или въведете китайски текст (до {maxCount} знака)',
  analyse_input_placeholder: 'Въведете китайски текст',
  free_practice_need_word: 'Изберете думи от таблицата или ги генерирайте на случаен принцип',
  free_practice_exercise_select_title: 'Изберете правилния отговор',
  free_practice_exercise_pairs_title: 'Съчетайте опциите',
  free_practice_exercise_meaning_title: 'Трябва да се преведе като',
  free_practice_exercise_sound_title: 'Трябва да се произнася като',
  free_practice_exercise_characters_title: 'Трябва да се напише като',
  free_practice_show_correct_answers: 'Покажи правилния отговор',
  free_practice_show_my_answers: 'Покажи моя отговор',
  free_practice_check: 'Провери моя отговор',
  free_practice_correct: 'Вярно.',
  free_practice_characters: 'Китайски йероглиф',
   hsk_introduce_objective_questions: 'Обективни въпроси',
  hsk_introduce_subjective_questions: 'Субективни въпроси',
  hsk_input_type_here: 'Моля, въведете отговора тук',
  hsk_translation_part_title: 'Превод част {count}',
  hsk_speaking_part_title: 'Говорене част {count}',
  subjective_reading_placeholder: 'Моля, отговорете на следните въпроси въз основа на горния текст…',
  hsk_write_by_artical: 'Моля, напишете текст въз основа на горните материали…',
  hsk_translation_by_artical: 'Моля, преведете въз основа на горните материали…',
  hsk_trasnlation_choose_language: 'Следва разделът за превод. Моля, изберете език.',
  choose_speaker: 'Изберете високоговорител',
  choose_microphone: 'Изберете микрофон',
  hsk_is_recording: 'Запис в процес',
  dialogue_speaking: 'Последната част е устният раздел. Моля, уверете се, че високоговорителят и микрофонът на устройството Ви работят правилно.',
  start_recording: 'Кликнете, за да започнете записа',
  hsk_write_count: 'Брой знаци',
  error_access_media: 'Грешка при достъп до медийното устройство',
  setSinkId_not_supported: 'Вашият браузър не поддържа {setSinkId}。',
  error_switch_device: 'Грешка при превключване на устройството',
  translation_section: 'Раздел за превод',
  speaking_section: 'Раздел за говорене',
  failed_upload_record: 'Неуспешно качване на аудио записа, моля, кликнете, за да го качите отново.',
  hsk_enter_next_segment_write_high: 'Желаете ли да предадете частта по писане? След подаване тази част приключва и не може да се връщате за промени.',
  hsk_enter_next_segment_translate_tip: 'Имате {count} въпроса в частта по превод, на които не сте отговорили,',
  hsk_enter_next_segment_translate: 'Желаете ли да предадете частта по превод? След подаване тази част приключва и не може да се връщате за промени.',
  hsk_enter_next_segment_speaking_tip: 'Имате {count} въпроса в частта по говорене, на които не сте отговорили,',
  Translating: 'Превод',
  Speaking: 'Говорене',

  back_to_home: 'Обратно към началната страница',
  about_us_desc:
    '<b>HSK Mock</b> е официална онлайн платформа за пробни изпити <b>HSK</b>, <b>HSK Устен</b> и <b>YCT</b>. Възпроизвежда реални условия на изпита, за да помогне на учащите се да се подготвят уверено, точно да оценят нивото си и да се развият цялостно.',
  who_we_are: 'Кои сме ние',
  who_we_are_desc:
    'HSK Mock е съвместен проект на <b>Chinese Testing International</b> и <b>Wo Hui Mandarin</b>, посветен на предоставянето на надеждни пробни изпити и учебни инструменти на учащите по света.',
  why_choose_hsk_mock: 'Защо да избереш HSK Mock?',
  about_us_carousel_1: 'Официална база с пробни тестове',
  about_us_carousel_1_content:
    'HSK Mock следва стриктно и пресъздава напълно структурата на официалните изпити HSK, HSK Устен и YCT.',
  about_us_carousel_2: 'Авторитетна система за оценяване',
  about_us_carousel_2_content:
    'HSK Mock използва същите стандарти за оценяване като официалните изпити, за да измери точно реалното ниво на кандидатите.',
  about_us_carousel_3: 'Ефективни учебни инструменти',
  about_us_carousel_3_content:
    'HSK Mock предлага специализирани упражнения по лексика за всяко ниво и интерактивни функции за подобряване на уменията по слушане, говорене, четене и писане.',
  about_us_carousel_4: 'Гъвкаво използване на различни устройства',
  about_us_carousel_4_content: 'HSK Mock поддържа работа както на компютър, така и на мобилни устройства – учи лесно навсякъде.',
  about_us_carousel_5: 'Изборът на учащите по целия свят',
  about_us_carousel_5_content: 'HSK Mock вече е помогнал на учащи от целия свят да постигнат езиковите си цели.',

  for_teachers_banner_title: 'Официална платформа за симулиране на изпити за училища и глобални екипи',
  for_teachers_banner_desc: 'Официалната платформа за симулиране на изпита на HSK включва напълно реални тестове, професионални оценки, усъвършенстване на речника и интелигентни упражнения, чрез HSK Mock можете да оцените нивото на китайския език онлайн по всяко време и навсякъде, за да изпитате истински изпити за HSK и YCT. Това е доверието на международните училища, университети, корпоративни екипи за човешки ресурси и мениджъри на глобалната мобилност.',
  for_teachers_banner_btn: 'Резервирайте демонстрация',

  for_schools: 'За училища и преподаватели',
  for_schools_desc: 'Подпомагайте студентите да се подготвят уверено за официално акредитираните HSK и YCT симулационни изпити.',
  for_schools_list_1: 'Процесът на изпита в съответствие с официалните изпити, симулиращ реална изпитна среда',
  for_schools_list_2: 'Поддръжка на множество устройства за онлайн тестване по всяко време и навсякъде',
  for_schools_list_3: 'HSK нива 1-3 и YCT1-4',
  for_schools_list_4: 'Проследяване на напредъка на хората и класовете по всяко време',

  for_corporates: 'За корпоративни и човешки екипи',
  for_corporates_desc: 'Гъвкава и бърза оценка на китайски език, която отговаря на мобилността на служителите, командирането, наемането и търговските нужди.',
  for_corporates_list_1: 'Предварителен езиков скрининг и вътрешни тестове',
  for_corporates_list_2: 'HSK ниво 1-3 незабавни резултати; Резултатите от изпита HSK 4-6 са достъпни в рамките на 48 часа',
  for_corporates_list_3: 'Проследяване на напредъка след обучението',
  for_corporates_list_4: 'Оценка онлайн, навсякъде и по всяко време',

  official_format: 'Официален процес',
  official_format_desc: 'Симулирайте реални изпити HSK и YCT, за да възстановите истинското изпитване.',
  smart_scoring: 'Професионално оценяване',
  smart_scoring_desc: 'Оценка въз основа на официални критерии.',
  progress_analytics: 'Анализ на напредъка',
  progress_analytics_desc: 'Подробен анализ и проследяване на резултатите на ученика или екипа.',
  remote_access: 'Дистанционен достъп',
  remote_access_desc: 'Изцяло базирана на мрежа, която се използва навсякъде и по всяко време.',

  why_use_hsk: 'Обект на официалната платформа за симулиране на изпити HSK Mock',
  international_schools: 'Международно училище',
  international_schools_desc: 'Предлага курсове по китайски език, които отговарят на стандартите HSK / YCT, с разширяеми възможности за оценка.',
  universities_institutes: 'Университети и професионални училища',
  universities_institutes_desc: 'Официална тестова подкрепа за академични курсове по китайски език.',
  global_corporates: 'Глобални компании',
  global_corporates_desc: 'Оценяване и разбиране на китайския език на служителите за позиции, ориентирани към китайския пазар.',
  language_training_providers: 'Образователни институции',
  language_training_providers_desc: 'Предоставяне на моделни изпити за учащите, които отговарят на официалните стандарти.',

  ready_to_access: 'Готови ли сте да оцените нивото си на китайски?',
  book_live_demo: "Резервирайте демонстрация на живо, отворете пробен акаунт, вижте анализ на резултатите и бързо започнете с HSK Mock.",
  book_demo: 'Резервирайте демонстрация',

  institutional_title: 'Оценка на китайски език за образователни институции',
  institutional_desc: 'Официалната платформа за симулативни изпити HSK Mock предлага онлайн оценка на китайски език, съответстваща на формата на официалните изпити HSK и YCT, помагайки на училища, университети и различни образователни институции да оценят нивото на китайски език на обучаемите и непрекъснато да следят напредъка им в обучението.',
  institutional_btn: 'Вижте решения за училища/институции',
  institutional_schools_title: 'Училища и образователни институции',
  institutional_schools_desc: 'Чрез автентични въпроси от минали изпити HSK, помагаме на учениците да се подготвят системно за изпитите HSK и YCT.',
  institutional_corp_title: 'Екипи на предприятия и човешки ресурси',
  institutional_corp_desc: 'Използва се за оценка на китайски език в проекти за набиране на персонал, командироване в чужбина или обучение, помагайки на предприятията по-ефективно да разбират и управляват езиковите умения на служителите си.',

  real_hsk_exam_content_new: 'Избери своето HSK ниво',
  real_hsk_exam_desc_new: 'Направете кратък тест за ниво, за да получите препоръчителното HSK ниво.',
  official_level_scoring_new: 'Участвайте в официалния симулативен изпит за HSK',
  vocabulary_boost_new: 'Подсилете речника си',
  vocabulary_boost_desc_new: 'Ние предлагаме безплатни карти с думи и интелигентни инструменти за упражнения.',

  confidence_card0_detail_desc: 'Направете кратък тест за ниво, за да получите препоръчително HSK ниво.',
  confidence_card0_detail_btn: 'Безплатен тест за самооценка',
  confidence_choose_level: 'Избери ниво',
  confidence_card1_detail_btn: 'Продължи',
  confidence_choose_method: 'Изберете метод за упражнение',
}
